module.exports = __webpack_public_path__ + "img/star-of-david.25af8598.png";